import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const ShareIcon = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg viewBox="0 0 32 32" {...props}>
    <path d="M22 26c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM7 19c-1.103 0-2-0.897-2-2s0.897-2 2-2 2 0.897 2 2-0.897 2-2 2zM22 7c1.103 0 2 0.897 2 2s-0.897 2-2 2-2-0.897-2-2 0.897-2 2-2zM22 21c-1.025 0-1.93 0.52-2.472 1.305l-9.66-4.476c0.078-0.27 0.132-0.54 0.132-0.83 0-0.32-0.063-0.62-0.155-0.91l9.814-5.24c0.55 0.696 1.39 1.15 2.34 1.15 1.653 0 3-1.347 3-3s-1.347-3-3-3-3 1.345-3 3c0 0.343 0.070 0.67 0.177 0.977l-9.79 5.225c-0.549-0.724-1.409-1.201-2.386-1.201-1.654 0-3 1.346-3 3s1.346 3 3 3c1.007 0 1.896-0.503 2.44-1.267l9.677 4.484c-0.070 0.252-0.117 0.51-0.117 0.783 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z" />
  </svg>
);

const StyledShareIcon = styled(ShareIcon)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;

export default StyledShareIcon;
